import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

/**
 * Reusable spinner component for loading states
 * @param {Object} props Component props
 * @param {string} props.text Text to display under the spinner
 * @param {string} props.size Icon size - 'sm', 'lg', '1x' through '10x'
 * @param {string} props.color Bootstrap color class (primary, secondary, success, etc.)
 * @param {Object} props.style Additional inline styles for the container
 * @param {string} props.className Additional classes for the container
 * @returns {Object} Spinner component
 */
const Spinner = ({
    text = "Cargando...",
    size = "5x",
    color = "primary",
    style = {},
    className = ""
}) => {
    return (
        <div
            className={`text-center py-5 ${className}`}
            style={{ minWidth: "200px", minHeight: "300px", ...style }}
        >
            <FontAwesomeIcon
                icon="circle-notch"
                spin
                size={size}
                className={`fa-spin mb-4 text-${color}`}
            />
            {text && <p className="mt-3">{text}</p>}
        </div>
    );
};

export default Spinner;